<template>
    <div class="content">
        <div class="head">
            <div>
                <p class="title">作业详情</p>
                <p @click="back()"
                   class="back"></p>
                <p class="preview"
                   @click="preview(taskType)">作业预览</p>
            </div>
        </div>
        <div class="time_box">
            <p class="jzTime">截止时间：{{ endDate }}</p>
            <p class="endTime"
               v-if="flagBoon">已截止</p>
        </div>
        <div class="tabs_tit">
            <div class="notab">
                完成情况
            </div>
        </div>
        <template v-if="loading">
            <div class="left">
                <div class="left_box">
                    <div class="box_bg1">
                        <div>
                            <p>{{finish}}人</p>
                            <p>已完成</p>
                        </div>
                        <div>
                            <p>{{unfinish}}人</p>
                            <p>未完成</p>
                            <p @click="cuicu">催促</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div class="list_box">
                        <div class="list_title">
                            <p>学生情况</p>
                            <!-- <p @click="news">写评语</p> -->
                        </div>
                    </div>
                    <div class="lists">
                        <div>
                            <p class="name">姓名</p>
                            <p class="score">成绩</p>
                            <p class="upTime">提交时间</p>
                        </div>
                    </div>
                    <div class="">
                        <div class="lists1_picbox clearfix"
                             v-if="true">
                            <div class="lists1_pic">
                                <p class="pic-name">菲菲<span class="tig-bu"
                                          v-if="true">补</span></p>
                                <p class="img-box"><img src="http://flv.m.xueceping.cn/upload_media/score/gift/2016/03/07/20160307092358954613.png"
                                         alt="">
                                </p>
                                <p class="pic-time">12月12日 23：22</p>
                            </div>
                            <div class="lists1_pic">
                                <p class="pic-name">菲菲<span class="tig-bu"
                                          v-if="true">补</span></p>
                                <p class="img-box"><img src="http://flv.m.xueceping.cn/upload_media/score/gift/2016/03/07/20160307092358954613.png"
                                         alt="">
                                </p>
                                <p class="pic-time">12月12日 23：22</p>
                            </div>
                            <div class="lists1_pic">
                                <p class="pic-name">菲菲<span class="tig-bu"
                                          v-if="true">补</span></p>
                                <p class="img-box"><img src="http://flv.m.xueceping.cn/upload_media/score/gift/2016/03/07/20160307092358954613.png"
                                         alt="">
                                </p>
                                <p class="pic-time">12月12日 23：22</p>
                            </div>
                            <div class="lists1_pic">
                                <p class="pic-name">菲菲<span class="tig-bu"
                                          v-if="true">补</span></p>
                                <p class="img-box"><img src="http://flv.m.xueceping.cn/upload_media/score/gift/2016/03/07/20160307092358954613.png"
                                         alt="">
                                </p>
                                <p class="pic-time">12月12日 23：22</p>
                            </div>
                            <div class="lists1_pic">
                                <p class="pic-name">菲菲<span class="tig-bu"
                                          v-if="true">补</span></p>
                                <p class="img-box"><img src="http://flv.m.xueceping.cn/upload_media/score/gift/2016/03/07/20160307092358954613.png"
                                         alt="">
                                </p>
                                <p class="pic-time">12月12日 23：22</p>
                            </div>
                        </div>
                        <!--<div class="list1_pic" v-else>
                          <p>菲菲</p>
                          <p>未完成</p>
                          <p class="no">--</p>
                      </div>-->
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>

        <div id="layui-m-layer"
             class="layui-m-layer layui-m-layer0"
             v-if='urge'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <textarea class="textar"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'>发到家长群里</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';
import headers from 'COMPONENTS/base/header.vue'
import results from 'VIEWS/chinese/inspect/resultList.vue'
import reports from 'VIEWS/chinese/inspect/reportList.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid,//21小学22初中
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            taskType: this.$route.params.taskType,//作业类型1课前2课后3课外
            testType: this.$route.params.testType,
            type: this.$route.params.type,//1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            taskList: [],
            tabNum: 1,
            finshList: [],//所有学生列表
            finish: null,//完成学生
            unfinish: null,//未完成
            asksList: [],//错误率数据
            knows: [],
            flagBoon: false,//截止时间
            city: 1111,
            endDate: null,
            students: null,
            unspec: null,
            loading: false,
            urge: false,
            information1: '你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！',
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
        }
    },
    created () {
        this.loading = true;
        this.type = this.type;
        //console.log(this.type)
        //this.getlist();
        /*if(localStorage.getItem('tabNum')){
                this.tabNum = localStorage.getItem('tabNum');
                this.tab(this.tabNum)
            }else{
                this.getlist()
            }*/
    },
    destroyed () {
    },
    methods: {
        back () {
            this.$router.go(-1)
            localStorage.setItem('tabNum', 1);
        },
        preview (taskType) {//作业预览
            if (taskType != 1) {
                this.$router.push("/preview/task/" + this.sid + "/" + this.taskId + "/" + this.testType)
            } else {
                this.$router.push("/preview/video/" + this.taskId)
            }
        },
        cuicu () {//催促
            if (Number(this.unfinish)) {
                //写评语
                this.urge = !this.urge;
                this.information1 = '你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！';
            } else {
                layer.tips('所有学生都已完成')
            }
        },
        cancel () {
            this.urge = !this.urge
        },
        release () {
            this.information1 = this.information1.replace(/(^\s*)|(\s*$)/g, "");
            this.information1 = this.information1.replace(/,/g, '，');
            if (this.information1.length > 200) {
                layer.tips('已经超过200字了')
                return false
            } else if (this.information1 == 0) {
                layer.tips('内容为空')
                return false
            }
            this.$http.post(API_URL_TASK_API + '/public/task/tea/share/in', {
                message_id: this.taskId,
                unit_class_id: this.classId,
                content: this.information1,
                type: 0
            }).then(res => {
                if (res.data.response == 'ok') {
                    this.urge = false;
                    let id = res.data.data.id;
                    let content = res.data.data.content;
                    let url = VUE_URL_HD + `/#/share/examine_task?sid=5&type=0&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    let title = `同步课堂`;
                    if (this.city_id == "411600") {
                        title = "随堂练";
                    }
                    // try {
                    //         appobject.Interactive(`ys_share,${title},${content},${url}`)
                    //       } catch (e) {
                    //         //console.log(`ys_share,${title},${content},${url}`)
                    //       }
                    this.appFunction("ys_share", `${title},${content},${url},${this.sid},${this.classId},0,0,教师检查作业催促发送到群里`)
                    layer.tips("发送成功！");
                }
            })
        },
        // news() { //一键写评语
        //   //this.$router.push('/sx/task/classdetail/new_common/' + this.taskid + '/' + this.classId)
        // },
        getlist () {
            let that = this;
            this.$http.post(API_URL_TASK_API + '/maths/check/task/detail', {
                "message_id": that.taskId,
                "sid": that.sid,
                "unit_class_id": that.classId
            }).then(res => {
                if (res.data.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    this.finshList = data.students;
                    this.finish = data.finish_num;
                    this.unfinish = data.unfinished_num;
                    this.unspec = data.special_num;
                    this.endDate = data.end_date;
                    //localStorage.setItem('unfinish', this.unfinish);
                    if (res.data.data.task) {
                        if (res.data.data.task.is_end == 1) {
                            this.flagBoon = true;
                        } else {
                            this.flagBoon = false;
                        }
                    }
                }
            })
        }
    },
    components: {
        headers,
        results,
        reports,
        loadingS
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    width: 100vw;
    background: #f5f9ff;
    overflow-x: hidden;
    min-height: 100%;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;
        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }
        .back {
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(../img/choose_back.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
        }
        .preview {
            position: absolute;
            top: 30px / $ppr;
            right: 24px / $ppr;
            font-size: 30px / $ppr;
            z-index: 10;
            color: #fff;
        }
    }
}

.time_box {
    width: 100%;
    height: 96px / $ppr;
    margin-top: 96px / $ppr;
    background: #5e89ef;
    .jzTime {
        padding-left: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        float: left;
    }
    .endTime {
        float: right;
        font-size: 30px / $ppr;
        color: #dde7fd;
        margin-right: 24px / $ppr;
        line-height: 96px / $ppr;
    }
}

.notab {
    width: 100%;
    height: 96px / $ppr;
    font-weight: bold;
    line-height: 96px / $ppr;
    text-align: left;
    font-size: 28px / $ppr;
    margin-bottom: 24px / $ppr;
    padding-left: 24px / $ppr;
    background-color: #fff;
    position: relative;
    z-index: 2;
}

.left {
    width: 100%;
    height: auto;
    .left_box {
        width: 100%;
        height: 239px / $ppr;
        background: #fff;
        padding-top: 23px / $ppr;
        .box_bg1 {
            width: 672px / $ppr;
            height: 238px / $ppr;
            background: url(./img/icon_bg1.png) no-repeat;
            background-size: 100%;
            margin: 0 auto;
            div {
                float: left;
                width: 330px / $ppr;
                height: 238px / $ppr;
                p {
                    width: 100%;
                }
                p:nth-child(1) {
                    height: 44px / $ppr;
                    line-height: 44px / $ppr;
                    text-align: center;
                    margin-top: 44px / $ppr;
                    color: #ff6600;
                    font-size: 44px / $ppr;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    height: 23px / $ppr;
                    line-height: 23px / $ppr;
                    text-align: center;
                    margin-top: 15px / $ppr;
                    color: #999;
                    font-size: 22px / $ppr;
                }
                p:nth-child(3) {
                    text-align: center;
                    margin-top: 34px / $ppr;
                    color: #5e89ef;
                    font-size: 22px / $ppr;
                }
            }
            div:nth-child(1) {
                margin-right: 12px / $ppr;
            }
        }
    }
}

.list {
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: 25px / $ppr;
    .list_box {
        width: 100%;
        border-bottom: 1px / $ppr solid #e2e5ec;
        .list_title {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            //font-weight:600;
            p:nth-child(1) {
                float: left;
                line-height: 96px / $ppr;
                font-size: 36px / $ppr;
                color: #333;
            }
            p:nth-child(2) {
                float: right;
                line-height: 96px / $ppr;
                font-size: 30px / $ppr;
                color: #5e89ef;
            }
        }
    }
    .lists {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        div {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #333;
            }
            .name {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
            }
            .score {
                width: 90px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 114px / $ppr;
            }
            .upTime {
                width: 260px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
            }
        }
    }
    .lists1 {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        .lists1_result {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #999;
                font-size: 30px / $ppr;
            }
            p:nth-child(1) {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
                position: relative;
                /*i{
                        width: 123px/$ppr;
                        display: inline-block;
                        float: left;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }*/
            }
            p:nth-child(2) {
                width: 90px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 90px / $ppr;
                i {
                    color: #ff8042;
                }
            }
            p:nth-child(3) {
                width: 290px / $ppr;
                line-height: 96px / $ppr;
                span {
                    float: right;
                    width: 14px / $ppr;
                    height: 26px / $ppr;
                    margin-top: 34px / $ppr;
                    margin-left: 32px / $ppr;
                    background: url(img/icon_next.png) no-repeat;
                    background-size: 100%;
                }
                .open {
                    width: 28px / $ppr;
                    height: 28px / $ppr;
                    margin-top: 33px / $ppr;
                    margin-left: 16px / $ppr;
                    background: url(img/icon_jia.png) no-repeat;
                    background-size: 100% 100%;
                }
                .colse {
                    width: 28px / $ppr;
                    height: 28px / $ppr;
                    margin-top: 33px / $ppr;
                    margin-left: 16px / $ppr;
                    background: url(img/icon_jian.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .no {
                //width: 260px/$ppr;
                text-align: center;
            }
        }
        .lists1_detail {
            padding: 40px / $ppr 0;
            background-color: #fff;
            border-top: 1px / $ppr solid #e2e5ec;
            ul {
                @include displayFlex();

                li {
                    @include flex();
                    text-align: center;
                    border-right: 1px / $ppr solid #e2e5ec;
                    &:last-child {
                        border: 0;
                    }
                    p {
                        position: relative;
                        font-size: 26px / $ppr;
                        color: #999;
                    }
                    .detail_tit {
                        font-size: 30px / $ppr;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 10px / $ppr;
                    }
                }
                .playicon {
                    display: inline-block;
                    width: 24px / $ppr;
                    height: 24px / $ppr;
                    position: relative;
                    top: 4px / $ppr;
                    margin-left: 16px / $ppr;
                    background: url(img/icon_play.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .lists1:last-child {
        border: 0;
    }
}

.noresources {
    width: 100%;
    height: 300px / $ppr;
    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

/*
    生词听写图片详情
    **/
.lists1_picbox {
    padding-top: 8px / $ppr;
    .lists1_pic {
        float: left;
        margin: 32px / $ppr 24px / $ppr 64px / $ppr;
        text-align: center;
        .pic-name {
            color: #333;
            font-size: 30px / $ppr;
            position: relative;
            .tig-bu {
                position: absolute;
                left: 0;
                top: -24px / $ppr;
                width: 40px / $ppr;
                padding: 1px / $ppr 0;
                font-size: 24px / $ppr;
                color: #fff;
                background-color: #66cc22;
                line-height: normal;
                text-align: center;
                border-radius: 2px;
            }
        }
        .img-box {
            margin: 16px / $ppr auto;
            img {
                width: 192px / $ppr;
                height: 160px / $ppr;
            }
        }
        .pic-time {
            font-size: 24px / $ppr;
            color: #999;
        }
    }
}

.layui-m-layerchild {
    text-align: center;
}

.textar {
    margin: auto 0;
    width: 86%;
    min-height: 200px / $ppr;
    margin: 30px / $ppr 0;
    background: #f0f0f0;
    border: none;
    padding: 20px / $ppr;
    border-radius: 10px / $ppr;
    font-size: 30px / $ppr;
}

.layui-m-layerbtn {
    span {
        width: 50%;
        background: #fff;
    }
    span:nth-child(1) {
        border-right: 1px / $ppr solid #f0f0f0;
    }
    span:nth-child(2) {
        color: #5e89ef;
        border-right: 1px / $ppr solid #f0f0f0;
    }
}
</style>
